/**
 * Filtros da /auditoria. Só apresentação: as opções vêm do domínio (entidades e
 * ações conhecidas) e do cadastro (atores) — nunca das linhas na tela, que são
 * só uma página da trilha.
 */

import type { OpcaoDeAcao, OpcaoDeEntidade } from '@/domain/auditoria/filtros';
import type { AtorDaAuditoria } from '@/services/datasources/auditoria';
import { Field, INPUT_CLS, Select } from './ui';

export interface ValoresDosFiltros {
  entidade: string;
  acao: string;
  ator: string;
  quem: string;
  de: string;
  ate: string;
}

interface Props {
  valores: ValoresDosFiltros;
  onChange: (campo: keyof ValoresDosFiltros, valor: string) => void;
  entidades: OpcaoDeEntidade[];
  acoes: OpcaoDeAcao[];
  atores: AtorDaAuditoria[];
}

export function FiltrosDaAuditoria({ valores, onChange, entidades, acoes, atores }: Props) {
  return (
    <section className="grid gap-3 sm:grid-cols-3 lg:grid-cols-6 rounded-lg border border-jf-border bg-jf-surface2 p-4">
      <Field label="Entidade" htmlFor="f-entidade">
        <Select id="f-entidade" value={valores.entidade} onChange={(v) => onChange('entidade', v)}>
          <option value="">Todas</option>
          {entidades.map((o) => (
            <option key={o.valor} value={o.valor}>
              {o.rotulo}
            </option>
          ))}
        </Select>
      </Field>
      <Field label="Ação" htmlFor="f-acao">
        <Select id="f-acao" value={valores.acao} onChange={(v) => onChange('acao', v)}>
          <option value="">Todas</option>
          {acoes.map((o) => (
            <option key={o.valor} value={o.valor}>
              {o.rotulo}
            </option>
          ))}
        </Select>
      </Field>
      <Field label="Ator" htmlFor="f-ator">
        <Select id="f-ator" value={valores.ator} onChange={(v) => onChange('ator', v)}>
          <option value="">Todos</option>
          {atores.map((a) => (
            <option key={a.id} value={a.id}>
              {a.nome}
            </option>
          ))}
        </Select>
      </Field>
      <Field label="Quem" htmlFor="f-quem">
        <Select id="f-quem" value={valores.quem} onChange={(v) => onChange('quem', v)}>
          <option value="">Todos</option>
          <option value="pessoas">Pessoas identificadas</option>
          <option value="sistema">Sistema, cargas e antes do login</option>
        </Select>
      </Field>
      <Field label="De" htmlFor="f-de">
        <input id="f-de" type="date" value={valores.de} onChange={(e) => onChange('de', e.target.value)} className={INPUT_CLS} autoComplete="off" />
      </Field>
      <Field label="Até" htmlFor="f-ate">
        <input id="f-ate" type="date" value={valores.ate} onChange={(e) => onChange('ate', e.target.value)} className={INPUT_CLS} autoComplete="off" />
      </Field>
    </section>
  );
}
